import '@fontsource/nunito/400.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import '@fontsource/nunito/800.css';
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/palettes/dark.class.css';
import './theme.css';
import './cards.css';
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonTab,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact,
} from '@ionic/react';
import { calendarOutline, cartOutline, homeOutline } from 'ionicons/icons';
import { useMessages } from './i18n/LanguageProvider';
import { PlanPage } from './plan/PlanPage';
import { ShoppingPage } from './shopping/ShoppingPage';
import { AppErrorBoundary } from './ErrorScreen';
import { SettingsProvider } from './settings/SettingsProvider';
import { AppDataProvider, useAppData } from './state/AppDataProvider';
import { useTheme } from './theme/use-theme';
import { TodayPage } from './today/TodayPage';

setupIonicReact();

// DE: Eine feste Funktion, damit die Datumsprüfung nicht bei jedem Zeichnen neu startet.
// EN: One fixed function so the date check does not restart on every render.
const now = () => new Date();

function Tabs() {
  const { t } = useMessages();
  useTheme(useAppData().data.appearance);
  return (
    <IonTabs>
      <IonTab tab="today">
        <TodayPage />
      </IonTab>
      <IonTab tab="plan">
        <PlanPage />
      </IonTab>
      <IonTab tab="shopping">
        <ShoppingPage />
      </IonTab>
      <IonTabBar slot="bottom">
        <IonTabButton tab="today">
          <IonIcon icon={homeOutline} aria-hidden="true" />
          <IonLabel>{t.tabToday}</IonLabel>
        </IonTabButton>
        <IonTabButton tab="plan">
          <IonIcon icon={calendarOutline} aria-hidden="true" />
          <IonLabel>{t.tabPlan}</IonLabel>
        </IonTabButton>
        <IonTabButton tab="shopping">
          <IonIcon icon={cartOutline} aria-hidden="true" />
          <IonLabel>{t.tabShopping}</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
}

/**
 * DE: App-Rahmen: drei Reiter ohne Router (Ionic-Tabs mit `IonTab`).
 * EN: App frame: three tabs without a router (Ionic tabs with `IonTab`).
 */
export function App() {
  return (
    <IonApp>
      <AppErrorBoundary storage={window.localStorage}>
        <AppDataProvider storage={window.localStorage} now={now} locale={navigator.language}>
          <SettingsProvider>
            <Tabs />
          </SettingsProvider>
        </AppDataProvider>
      </AppErrorBoundary>
    </IonApp>
  );
}
